import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, switchMap, throwError } from 'rxjs';
import { AuthApiService } from '../api/auth.api.service';
import { BranchService } from '@core/services/helpers/branch.service';

@Injectable()
export class ApiTokenInterceptor implements HttpInterceptor {
  constructor(
    private AuthApiService: AuthApiService,
    private branchService: BranchService
  ) {}

  intercept<T>(request: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next
      .handle(this.addAccessToken(request))
      .pipe(catchError((error: HttpErrorResponse) => this.handleApiError<T>(error, request, next)));
  }

  private handleApiError<T>(
    error: HttpErrorResponse,
    request: HttpRequest<T>,
    next: HttpHandler
  ): Observable<HttpEvent<T>> {
    const skippableUrls: string[] = ['/logout', '/instructor/me/registration'];
    if (error.status === HttpStatusCode.Unauthorized && skippableUrls.every(url => !(error.url || '').endsWith(url))) {
      if (this.AuthApiService.getRefreshToken()) {
        return this.refreshToken(request, next);
      }
      this.AuthApiService.logOut().subscribe();
    }

    return throwError(() => error);
  }

  private refreshToken<T>(request: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    return this.AuthApiService.refreshToken().pipe(
      switchMap(({ accessToken }) => {
        const transformedRequest: HttpRequest<T> = this.addAccessToken<T>(request, accessToken);
        return next.handle(transformedRequest);
      }),
      catchError(error => {
        this.AuthApiService.logOut().subscribe();
        return throwError(() => error);
      })
    );
  }

  private addAccessToken<T>(request: HttpRequest<T>, token?: string): HttpRequest<T> {
    const accessToken: string | null = (token || this.AuthApiService.getAccessToken()) ?? this.branchService.token();
    return request.clone({ setHeaders: { Authorization: `Bearer ${accessToken}` } });
  }
}
